import * as RadixTooltip from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export const TooltipProvider = RadixTooltip.Provider

type TooltipProps = {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  className?: string
}

/** Wrap a single focusable element. Content is supplementary, never the only label. */
export function Tooltip({ content, children, side = 'top', align = 'center', className }: TooltipProps) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={8}
          className={cn(
            'z-50 max-w-xs rounded-lg bg-ink/90 px-2.5 py-1 text-xs font-medium text-canvas shadow-popover backdrop-blur-md',
            'origin-[var(--radix-tooltip-content-transform-origin)] data-[state=delayed-open]:motion-safe:animate-pop-in data-[state=instant-open]:motion-safe:animate-pop-in data-[state=closed]:motion-safe:animate-pop-out',
            className,
          )}
        >
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  )
}
